import ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { mutatorAction } from 'satcheljs';

/**
 * Sets the rsvpUnitAriaDetails value of the item.
 * @param itemId id of item
 * @param rsvpUnitAriaDetails aria details value to set
 */
export const setRsvpUnitAriaDetailsForItem = mutatorAction(
    'setRsvpUnitAriaDetailsForItem',
    (itemId: string, rsvpUnitAriaDetails: string) => {
        const mailStoreItem = getMailStore().items.get(itemId);
        if (!mailStoreItem) {
            return;
        }
        (mailStoreItem as ClientItem).rsvpUnitAriaDetails = rsvpUnitAriaDetails;
    }
);
